import { render, staticRenderFns } from "./EcgView.vue?vue&type=template&id=2414572b&scoped=true&"
import script from "./EcgView.vue?vue&type=script&lang=js&"
export * from "./EcgView.vue?vue&type=script&lang=js&"
import style0 from "./EcgView.vue?vue&type=style&index=0&id=2414572b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2414572b",
  null
  
)

export default component.exports